import {
	DislikedOfferIdsListDto,
	OfferIdsDto
} from '@wwt/entities/api/search-response'
import type { Offer } from '@wwt/entities/search-response'

import { getFullRoomId, getFullRoomIdByIds } from '@/entities/offer'

export const getDisliked = (
	dislikedOffers: DislikedOfferIdsListDto,
	offer: Offer
) => {
	return dislikedOffers.disliked.includes(getFullRoomId(offer))
}

export const getDislikedByIds = (
	dislikedOffers: DislikedOfferIdsListDto,
	offer: OfferIdsDto
) => {
	return dislikedOffers.disliked.includes(getFullRoomIdByIds(offer))
}
